export default __webpack_public_path__ + "static/media/me.40363195.JPG";